<template>
  <div class="home">
      <v-card class="unbound-card">
          <v-card-title>
              <span class="page-title">Sponsorship Package for {{AuthSvc.getYear()}}}</span>

          </v-card-title>
          If you would like to be a sponsor, please email <b>Vincent Tran</b> for more information
          at <b>dfwvga.info@dfwvga.com</b>

          <br><br>

          <v-card-text>
              <span class="label14">SILVER - Standard Package $500</span>
              <pre>
        1. DFWVGA membership for current season
        2. Company yard sign displayed at all tournaments
        3. Company advertisement published on our dfwvga.com website
        4. Honorable mentions on all DFWVGA social media platforms
              </pre>
          </v-card-text>

          <br>
          <v-card-text>
              <span class="label14">GOLD - $1000</span>
              <pre>
        1. Standard package
        2. One complimentary round of golf to any of DFWVGA tournament for current season
        3. Invitation 2 additional guests to DFWVGA Club year end banquet
        4. Custom DFWVGA Sponsorship flag to be flown at all our tournaments
              </pre>
          </v-card-text>

          <br>
          <v-card-text>
              <span class="label14">PLATINUM - $2500</span>
              <pre>
        1. Tournament name sponsor
        2. Standard package
        3. Two complimentary rounds of golf to any of DFWVGA tournament for current season
        4. Invitation 4 additional guests to DFWVGA Club year end banquet
        5. Sponsorship table to promote your business during any of our tournaments
        6. Custom DFWVGA Sponsorship flag to be flown at all our tournaments
              </pre>
          </v-card-text>

        <br>
        <v-card-text>
          DFWVGA is a 501 (c) (7) Entity. Sponsorship donation/due paid to 501 (c) (7) Entity are not tax
          deductible.
        </v-card-text>
      </v-card>


      <v-card>
          <v-img class="sponsor-img" :src="require(`../assets/img/sponsors/sponsor-logo.png`)">
          </v-img>
      </v-card>

  </div>
</template>

<script>
  export default {
    name: "sponsors",
    data: () => ({
      sponsors: null
    })
  }
</script>

<style scoped>

  .sponsor-img {
    display: block;
    margin: 7px auto;
    border-radius: 5px;
  }

  @media (min-width: 768px) {

  }
</style>